import { useTranslate } from 'core/hooks/useTranslate';
import { MAIN_CONTENT_ID } from 'core/layout/constants';
import PdfViewerFullScreen from 'core/modules/components/pdfViewers/PdfViewerFullScreen/PdfViewerFullScreen';
import { IA_POLITICS } from 'edelvives/config/config';
import React from 'react';

const AIPolitics = () => {
  const { t } = useTranslate();
  return (
    <main id={MAIN_CONTENT_ID} tabIndex={-1}>
      <h1 className="sr-only">{t('titles:AIPolicy')}</h1>
      <PdfViewerFullScreen ariaLabel={t('titles:AIPolicy')} url={IA_POLITICS.es} />
    </main>
  );
};

export default AIPolitics;
